<template>
  <div>
    <v-data-table
      dense
      multi-sort
      hide-default-footer
      class="base-table elevation-0"
      mobile-breakpoint="800"
      :disable-sort="$vuetify.breakpoint.smAndDown"
      :items-per-page="$vuetify.breakpoint.mdAndUp ? 5 : 1"
      :items="items"
      :page.sync="currentPage"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope"/>
      </template>
    </v-data-table>
    <v-pagination
      v-model="currentPage"
      :hidden="$vuetify.breakpoint.mdAndUp && items.length <= 5"
      :length="$vuetify.breakpoint.mdAndUp ? (Math.ceil(items.length/5)) : (items.length/1)"
    ></v-pagination>
  </div>
</template>

<script>
  /** Standard Table of this project */
  export default {
    name: 'BaseTable',

    props: {
      // needed
      items: { type: [Object, Array],  default: ()=>({})},
    },

    data: ()=>({
      currentPage: 1
    })
  }
</script>

<style lang="scss">
  /* Adds spaces between data table data */
  /* reduces font size of data tables */
  .base-table {
    th, td {
      border: none !important;
      font-size: smaller !important;
      // margin: 1px !important;
      padding-bottom: 10px !important;
    }
  }
</style>